var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"failed-header-icon",attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{staticClass:"circle",attrs:{"cx":"50","cy":"50","r":"50"}}),_c('path',{staticClass:"cross",attrs:{"d":"M 30 30 l 40 40 M 30 70 l 40 -40"}})])}
var staticRenderFns = []

export { render, staticRenderFns }